const CapManagementActionTypes = {
  GET_CAPSLIST: 'GET_CAPSLIST',
  UPLOAD_CAP_CSV: 'UPLOAD_CAP_CSV',
  ADD_CAP: 'ADD_CAP',
  DELETE_CAP: 'DELETE_CAP',
  CLEAR_RESPONSE: 'CLEAR_RESPONSE',
};

export default CapManagementActionTypes;
